export const VERY_SMALL = 3
export const SMALL = 5
export const BIG = 10
